import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import * as firebase from 'firebase/app';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  isLinear = true;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;

  private user_id:string;
  private user_name:string;
  private user_email:string;

  ngOnInit(): void {
    var user = firebase.default.auth().currentUser;
    this.user_id = user.uid;
    this.user_email = user.email;
    this.user_name = user.displayName;
  }

  buttonClicked(buttonName: string) {
    firebase.default.analytics().logEvent(buttonName, {
      'uid': this.user_id,
      'email': this.user_email,
      'name': this.user_name,
    })
  }

  changeStepper(event) {
    var chapterName = 'Chapter ' + String(event.selectedIndex);
    firebase.default.analytics().logEvent(chapterName, {
      'uid': this.user_id,
      'email': this.user_email,
      'name': this.user_name
    })
  }

  constructor(private _formBuilder: FormBuilder, public dialog: MatDialog) {
  }

  openModal(templateRef) {
    let dialogRef = this.dialog.open(templateRef, {
         width: '300px',
    });

    dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
    });

  }

}
